module.exports = __webpack_public_path__ + "static/img/banercroc.2c417c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banercroc.png
// module id = l8OV
// module chunks = 1